import { useEffect, useState } from 'react';
import { getAiBalance, AiBalance } from 'services/ai.service';

export const useAiBalance = () => {
  const [data, setData] = useState<AiBalance | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetch = () => {
    setIsLoading(true);
    getAiBalance()
      .then(setData)
      .catch(() => setData(null))
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    fetch();
    const interval = setInterval(fetch, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return { data, isLoading };
};
